'use client';
import styled from 'styled-components';

const TourContentTitle = styled.strong`
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export default TourContentTitle;
